import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  selectInput: {
    fontSize: '13px',
    color: '#717171',
    '&::before': {
      border: 'none'
    }
  },
  disabledMenuItem: {
    display: 'none'
  }
});

export default useStyles;
